import React from "react";


const Home2 = () => {

   

    return (
            <section className="home" id="home">
                <img src="/img/home.jpg" alt="back" className="home__banner" />
                <div className="home__container__banner container grid">
                    <div className="home__data">
                        <span className="home__data-subtitle">Manejo integral</span>
                        <h1 className="home__data-title">FRATELLI<br></br> Control de <b>plagas <br></br></b></h1>
                    </div>
                </div>
            </section>
    )



}
export default Home2;